import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IndexFormationService } from 'src/services/index-formation.service';
import { IndexFormationDetail } from 'src/models/indexFormationDetail';

import { MatTableModule } from '@angular/material/table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-index-formation-detail',
    imports: [MatTableModule, TranslateModule, MatProgressSpinnerModule, MatIconModule, MatTooltipModule],
    templateUrl: './index-formation-detail.component.html',
    styleUrl: './index-formation-detail.component.scss'
})
export class IndexFormationDetailComponent implements OnInit {
  detail: any[] = [];
  isLoading = false;
  displayedColumns: string[] = ['property', 'value'];
  thumbnailMdUrl: string | null = null;
  quizViewerUrl: string | null = null;
  quizSolutionaryUrl: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private indexFormationService: IndexFormationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    const nomPackage = this.route.snapshot.paramMap.get('nomPackage');
    if (nomPackage) {
      this.isLoading = true;
      this.indexFormationService.getFormation(nomPackage).subscribe({
        next: (data: IndexFormationDetail) => {
          this.thumbnailMdUrl = data.thumbnailMdUrl || null;
          this.quizViewerUrl = data.quizViewerUrl || null;
          this.quizSolutionaryUrl = data.quizSolutionaryUrl || null;
          this.detail = [
            {
              propertyKey: 'INDEX_FORMATION.SCORM_2004_ZIP',
              value: data.scorm2004Url || '-',
              isUrl: !!data.scorm2004Url,
              fileName: this.extractFileName(data.scorm2004Url)
            },
            {
              propertyKey: 'INDEX_FORMATION.SCORM_2004_ZIP_IGNORE_LEARNER_LANGUAGE',
              value: data.scorm2004IgnoreLearnerLanguageUrl || '-',
              isUrl: !!data.scorm2004IgnoreLearnerLanguageUrl,
              fileName: this.extractFileName(data.scorm2004IgnoreLearnerLanguageUrl)
            },
            {
              propertyKey: 'INDEX_FORMATION.SCORM_2004_ZIP_OBJECTIVES_LANGUAGE_LOCATION',
              value: data.scorm2004ObjectivesLanguageLocationInSuspendDataUrl || '-',
              isUrl: !!data.scorm2004ObjectivesLanguageLocationInSuspendDataUrl,
              fileName: this.extractFileName(data.scorm2004ObjectivesLanguageLocationInSuspendDataUrl)
            },
            {
              propertyKey: 'INDEX_FORMATION.SCORM_12_ZIP',
              value: data.scorm12Url || '-',
              isUrl: !!data.scorm12Url,
              fileName: this.extractFileName(data.scorm12Url)
            },
            {
              propertyKey: 'INDEX_FORMATION.XAPI_ZIP',
              value: data.xapiUrl || '-',
              isUrl: !!data.xapiUrl,
              fileName: this.extractFileName(data.xapiUrl)
            },
            ...(data.thumbnailMdUrl ? [{
              propertyKey: 'INDEX_FORMATION.THUMBNAIL',
              value: data.thumbnailMdUrl,
              isImage: true
            }] : []),
            { propertyKey: 'INDEX_FORMATION.TITRE_FR', value: data.nomFR, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.TITRE_EN', value: data.nomEN, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.TITRE_ES', value: data.nomES, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.INFO_FR', value: data.infoFR, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.INFO_EN', value: data.infoEN, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.INFO_ES', value: data.infoES, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.DESCRIPTION_FR', value: data.descriptionFR, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.DESCRIPTION_EN', value: data.descriptionEN, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.DESCRIPTION_ES', value: data.descriptionES, isUrl: false },
            { propertyKey: 'INDEX_FORMATION.DUREE_MINUTES', value: data.dureeMinutes || '-', isUrl: false },
            { propertyKey: 'INDEX_FORMATION.VIMEO_ID_FR', value: data.vimeoIdFR || '-', isUrl: false },
            { propertyKey: 'INDEX_FORMATION.VIMEO_ID_EN', value: data.vimeoIdEN || '-', isUrl: false },
            { propertyKey: 'INDEX_FORMATION.VIMEO_ID_ES', value: data.vimeoIdES || '-', isUrl: false },
            ...(data.references && data.references.length > 0
              ? [{
                propertyKey: 'INDEX_FORMATION.REFERENCES',
                value: data.references,
                isReferences: true
              }]
              : []),
            {
              propertyKey: 'INDEX_FORMATION.QUIZ_VIEWER_URL',
              value: data.quizViewerUrl || '-',
              isUrl: !!data.quizViewerUrl,
              fileName: this.extractFileName(data.quizViewerUrl)
            },
            {
              propertyKey: 'INDEX_FORMATION.QUIZ_SOLUTIONARY_URL',
              value: data.quizSolutionaryUrl || '-',
              isUrl: !!data.quizSolutionaryUrl,
              fileName: this.extractFileName(data.quizSolutionaryUrl)
            }
          ];
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
    }
  }

  goBack() {
    this.router.navigate(['/index-formation']);
  }

  openQuizDocument(url: string | null): void {
    if (!url) {
      return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private extractFileName(url: string | null | undefined): string {
    if (!url) return '';
    try {
      return url.split('/').pop() || url;
    } catch {
      return url;
    }
  }
}
